import { Component, inject, input, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AlertService } from 'src/app/services/alert.service';
import { UploadService } from 'src/app/services/upload.service';

@Component({
  selector: 'app-document-upload',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    TranslateModule
],
  templateUrl: './document-upload.component.html',
  styleUrl: './document-upload.component.scss'
})
export class DocumentUploadComponent {
  private readonly uploadService = inject(UploadService);
  private readonly alertService = inject(AlertService);

  id = input<string>();
  label = input.required<string>();
  control = input.required<any>();
  type = input.required<string>();

  selectedFile = signal<File | null>(null);
  fileName = '';

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    const file = input.files[0];

    this.selectedFile.set(file);
    this.fileName = file.name;

    this.uploadService.uploadFile(file, this.type()).subscribe({
      next: (res: any) => {
        this.control().setValue(res.data.key);
        this.control().markAsDirty();
        this.control().markAsTouched();

        input.value = '';
      },

      error: () => {
        this.alertService.show({
          type: 'error',
          subtitle: 'FILE_UPLOAD.UPLOAD_ERROR'
        });

        input.value = '';
      },
    });
  }

  removeFile(input: HTMLInputElement) {
    this.selectedFile.set(null);

    this.control().reset();
    this.control().markAsDirty();
    this.control().markAsTouched();
    this.fileName = '';

    input.value = '';
  }

  downloadFile() {
    const id = this.id();

    if (id) {
      this.uploadService.downloadFile(id).subscribe({
        next: (response) => {
          const blob = response.body;

          if (!blob) {
            return;
          }

          const fileName = this.control().value || 'download';
          this.downloadFromBlob(blob, fileName);
        },
      });

      return;
    }

    const file = this.selectedFile();

    if (!file) {
      return;
    }

    this.downloadFromBlob(file, file.name);
  }

  private downloadFromBlob(blob: Blob, fileName: string) {
    const url = globalThis.URL.createObjectURL(blob);
    const anchor = document.createElement('a');

    anchor.href = url;
    anchor.download = fileName;

    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    globalThis.URL.revokeObjectURL(url);
  }
}
